import { Box, Paper, Typography } from '@mui/material'
import { type ReactNode } from 'react'

export const SectionCard = ({ title, children, testId }: { title: string, children: ReactNode, testId?: string }): JSX.Element => (
  <Paper variant='outlined' sx={{ p: '20px', borderRadius: '8px' }} data-testid={testId}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
      <Typography variant='h4'>{title}</Typography>
    </Box>
    {children}
  </Paper>
)
